import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import ModalConfirmacao from "@/components/ModalConfirmacao";

const formatCPF = (value) => value.replace(/\D/g, "").replace(/(\d{3})(\d)/, "$1.$2")
  .replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2").slice(0, 14);

const formatTelefone = (value) => value.replace(/\D/g, "")
  .replace(/(\d{2})(\d)/, "($1)$2").replace(/(\d{5})(\d)/, "$1-$2").slice(0, 15);

const formatData = (value) => value.replace(/\D/g, "")
  .replace(/(\d{2})(\d)/, "$1/$2").replace(/(\d{2})(\d)/, "$1/$2").slice(0, 10);

const removeMask = (value) => value.replace(/\D/g, "");

const formatDateForBackend = (value) => {
  const only = value.replace(/\D/g, "");
  if (only.length === 8) return `${only.slice(4, 8)}-${only.slice(2, 4)}-${only.slice(0, 2)}`;
  return "";
};

export default function Cadastro() {
  const [dados, setDados] = useState({
    nome: "",
    email: "",
    password: "",
    confirmPassword: "",
    cpf: "",
    rg: "",
    telefone: "",
    data_nascimento: "",
  });

  const [erro, setErro] = useState("");
  const [modalAberto, setModalAberto] = useState(false);
  const [senhaVisivel, setSenhaVisivel] = useState(false);
  const [confirmSenhaVisivel, setConfirmSenhaVisivel] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "cpf") value = formatCPF(value);
    if (name === "telefone") value = formatTelefone(value);
    if (name === "data_nascimento") value = formatData(value);
    if (name === "nome") value = value.toUpperCase();

    setDados({ ...dados, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");

    if (dados.password !== dados.confirmPassword) {
      setErro("As senhas não coincidem.");
      return;
    }

    const payload = {
      ...dados,
      cpf: removeMask(dados.cpf),
      telefone: removeMask(dados.telefone),
      data_nascimento: formatDateForBackend(dados.data_nascimento),
    };

    try {
      await axios.post("/api/public/api/register", payload);
      setModalAberto(true);
    } catch (err) {
      const msg = err.response?.data?.message || "Erro ao cadastrar. Tente novamente.";
      const erros = err.response?.data?.errors;
      if (erros) {
        const firstError = Object.values(erros)[0][0];
        setErro(firstError);
      } else {
        setErro(msg);
      }
    }
  };

  return (
    <div className="min-h-screen bg-cover bg-center bg-no-repeat relative"
      style={{ backgroundImage: "url('/images/bg-login.jpg')" }}>
      
      <div className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-sm" />

      <div className="relative z-10 flex justify-center items-center py-20">
        <div className="bg-white/10 backdrop-blur-md p-8 rounded-2xl w-full max-w-md border border-white/20 text-white shadow-2xl">
          <h2 className="text-2xl font-bold text-center mb-6">Cadastro</h2>

          {erro && <p className="text-red-400 text-sm text-center mb-4">{erro}</p>}

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input label="Nome" name="nome" value={dados.nome} onChange={handleChange} />
            <Input label="E-mail" type="email" name="email" value={dados.email} onChange={handleChange} />
            
            <PasswordInput label="Senha" name="password" value={dados.password} onChange={handleChange} visivel={senhaVisivel} setVisivel={setSenhaVisivel} />
            <PasswordInput label="Confirme a Senha" name="confirmPassword" value={dados.confirmPassword} onChange={handleChange} visivel={confirmSenhaVisivel} setVisivel={setConfirmSenhaVisivel} />

            <Input label="CPF" name="cpf" value={dados.cpf} onChange={handleChange} />
            <Input label="RG" name="rg" value={dados.rg} onChange={handleChange} />
            <Input label="Telefone" name="telefone" value={dados.telefone} onChange={handleChange} />
            <Input label="Data de Nascimento" name="data_nascimento" value={dados.data_nascimento} onChange={handleChange} placeholder="DD/MM/AAAA" />

            <button
              type="submit"
              className="w-full py-3 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 hover:scale-105 hover:brightness-110 transition-all rounded-xl font-bold shadow-lg"
            >
              Cadastrar
            </button>

            <button
              type="button"
              onClick={() => navigate("/login")}
              className="w-full mt-2 text-sm text-yellow-300 hover:underline text-center"
            >
              Já tem conta? Fazer login
            </button>
          </form>
        </div>
      </div>

      <ModalConfirmacao
        show={modalAberto}
        titulo="Cadastro Concluído!"
        mensagem="Seu cadastro foi realizado com sucesso."
        onConfirm={() => {
          setModalAberto(false);
          navigate("/login");
        }}
        hideCancelButton
      />
    </div>
  );
}

function Input({ label, name, value, onChange, type = "text", placeholder }) {
  return (
    <div>
      <label className="block text-sm mb-1">{label}</label>
      <input
        type={type}
        name={name}
        value={value}
        placeholder={placeholder || label}
        onChange={onChange}
        className="w-full px-3 py-2 bg-white/10 text-white rounded-lg border border-white/20 focus:outline-none focus:ring-2 focus:ring-yellow-400"
        required
      />
    </div>
  );
}

function PasswordInput({ label, name, value, onChange, visivel, setVisivel }) {
  return (
    <div>
      <label className="block text-sm mb-1">{label}</label>
      <div className="relative">
        <input
          type={visivel ? "text" : "password"}
          name={name}
          value={value}
          onChange={onChange}
          className="w-full px-3 py-2 pr-10 bg-white/10 text-white rounded-lg border border-white/20 focus:outline-none focus:ring-2 focus:ring-yellow-400"
          required
        />
        <span
          onClick={() => setVisivel(!visivel)}
          className="absolute right-3 top-2.5 text-yellow-300 cursor-pointer"
        >
          {visivel ? <FaEyeSlash /> : <FaEye />}
        </span>
      </div>
    </div>
  );
}
